<template>
	<div class="c-datetime">
		<el-date-picker v-model="valueData" :type="compType" :placeholder="placeholder" :value-format="format" :picker-options="pickerOptions"></el-date-picker>
	</div>
</template>

<script>
	export default {
		props: {
			value: [String, Array],
			
			type: {
				type: String,
				default: 'datetime'
			},
			
			range: Boolean,
			
			placeholder: String
		},

		data() {
			return {
				valueData: this.value,
				pickerOptions: {
					shortcuts: [{
						text: '本周',
						onClick(picker) {
							let date = new Date();
							let start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - (date.getDay() || 7) + 1);
							let end = new Date();
							end.setTime(start.getTime() + 3600 * 1000 * 24 * 7 - 1000);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '本月',
						onClick(picker) {
							let date = new Date();
							let start = new Date(date.getFullYear(), date.getMonth(), 1);
							let end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '本季度',
						onClick(picker) {
							function getQuarterStartMonth(){  
								let month = date.getMonth();
								if (month < 3) {   
									return 0;   
								}   
								if (2 < month && month < 6) {   
									return 3;   
								}   
								if (5 < month && month < 9) {   
									return 6;   
								}   
								if (month > 8) {   
									return 9;   
								}   
							} 
							let date = new Date();
							let start = new Date(date.getFullYear(), getQuarterStartMonth(), 1);
							let end = new Date(date.getFullYear(), getQuarterStartMonth() + 3, 0, 23, 59, 59);
							picker.$emit('pick', [start, end]);
						}
					}]
				}
			}
		},
		
		computed: {
			compType() {
				return `${this.type}${this.range ? 'range' : ''}`;
			},
			
			format() {
				switch (this.type) {
				case 'datetime':
					return 'yyyy-MM-dd HH:mm:ss';
					
				case 'date':
					return 'yyyy-MM-dd';
					
				case 'time':
					return 'HH:mm:ss';
				}
				
				return '';
			}
		},
		
		watch: {
			value(val) {
				this.valueData = val;
			},
			
			valueData(val) {
				this.$emit('input', val || []);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-datetime {
		>>> .el-date-editor {
			display: block;
			width: auto;
			
			.el-input__inner {
				height: 38px;
				border-radius: 0;
				font-size: 14px;
				transition: all .3s ease;
				
				&:focus {
					border-color: #bbb;
				}
			}
			
			.el-input__icon {
				line-height: 38px;
			}
		}
		
		>>> .el-range-editor {
			height: 38px;
			border-radius: 0;
			font-size: 0;
			transition: all .3s ease;
				
			&.is-active {
				border-color: #bbb;
			}
				
			&.el-input__inner {
				padding: 0 5px 0 10px;
			}
			
			.el-range-input {
				height: 36px;
				font-size: 14px;
				text-align: left;
			}
			
			.el-range-separator {
				height: 36px;
				line-height: 36px;
			}
			
			.el-input__icon {
				line-height: 36px;
			}
		}
	}
</style>